var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 21",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.437a.75.75 0 01.75.75v3.023l1.447 1.447a.75.75 0 01-1.06 1.06L9.47 11.052a.75.75 0 01-.22-.53V7.187a.75.75 0 01.75-.75z",
    fill: "#48525C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.441 5.362A6.75 6.75 0 003.288 9.763a.75.75 0 01-1.493-.152 8.25 8.25 0 111.497 5.634v1.942a.75.75 0 01-1.5 0v-4.166a.75.75 0 01.75-.75h4.166a.75.75 0 010 1.5h-2.58A6.75 6.75 0 1014.44 5.36z",
    fill: "#48525C"
  })));
};
export default SvgReset;